import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10 text-gray-800">
      <h1 className="text-4xl sm:text-5xl font-extrabold mb-8 text-center text-gray-800 underline decoration-indigo-500">
        Terms and Conditions
      </h1>

      <p className="mb-4 font-semibold">Effective Date: 27th June 2025</p>

      <section className="mb-8">
        <p className="mb-2">
          Welcome to TACTOS Strategic Solutions LLP (“TACTOS”, “we”, “us”, or
          “our”). These Terms and Conditions (“Terms”) govern your use of our
          website and web application (the “Platform”), including all features,
          tools, and services provided through it. By accessing or using the
          Platform, you agree to be bound by these Terms. If you do not agree,
          please refrain from using our Platform.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">1. Eligibility</h2>
        <p>
          To use the Platform, you must be at least 18 years old and capable of
          forming a binding contract. If you are using the Platform on behalf of
          an organization, you represent that you have the authority to bind
          that organization to these Terms.{" "}
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          2. Description of Services
        </h2>
        <h3 className="mb-2">TACTOS provides a digital platform for:</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>Business ideation and startup resources</li>
          <li>Conducting startup events</li>
          <li>
            A job portal for entrepreneurial opportunities and startup hiring
          </li>
          <li>
            Tech Support services including web/app development and digital
            marketing
          </li>
          <li>Commission-free quotation services based on startup budget</li>
          <li>
            An Invest in Startups page to attract local investors for startups
          </li>
          <li>
            Dedicated startup dashboards for job postings, content uploads
            (including fundraising), and controlled event listings
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">3. Refund Policy</h2>
        <p className="mb-2">
          <span className="font-bold">Event Attendance:</span> Refunds are not
          applicable if the attendee fails to attend the event.
        </p>
        <p className="mb-2">
          <span className="font-bold">Organizer-Cancelled Events:</span> If an
          event is cancelled by the organizer, a full refund will be issued to
          all registered participants.
        </p>
        <p className="mb-2">
          <span className="font-bold">Natural Cancellations:</span> Events
          cancelled due to natural causes (such as extreme weather, national
          emergencies, or force majeure conditions) will also qualify for a full
          refund.
        </p>
        <p className="mb-2">
          <span className="font-bold">Matrimony Registration:</span> Is
          non-refundable under all circumstances
        </p>
        <p className="mb-2">
          <span className="font-bold">Startup Registration:</span> Is
          non-refundable under all circumstances. Registrations can be cancelled
          at any given time.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          4. Startup Registration Fee
        </h2>
        <p className="mb-2">
          The price for registering a startup on the Platform is ₹999. This
          registration:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>Is valid for one year from the date of registration</li>
          <li>Is non-refundable under all circumstances</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">5. Invest in Startups</h2>
        <p className="mb-2">
          TACTOS offers an 'Invest in Startups' feature on the Platform,
          specifically designed to help startups gain visibility among local
          investors. This dedicated section allows startups to showcase their
          ventures, funding needs, business models, and traction to potential
          backers from their region or industry. The aim is to foster vibrant
          local entrepreneurial ecosystems by encouraging investments that stay
          within and help grow the community.
        </p>
        <p className="mb-2 font-semibold">Startup Responsibilities:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            Submit accurate and up-to-date business information, including pitch
            decks, valuation expectations, and founder profiles.
          </li>
          <li>
            Clearly indicate their fundraising stage and capital requirements.
          </li>
          <li>
            Respond promptly to investor inquiries facilitated through the
            Platform.
          </li>
        </ul>
        <p className="mb-2 font-semibold">TACTOS Commitments:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            Provide standardized listing templates to ensure a professional and
            structured presentation.
          </li>
          <li>
            Promote selected startups via newsletters, online events (e.g.,
            webinars), and curated investor outreach programs.
          </li>
          <li>
            Allow verified local investors to explore startup profiles and
            initiate conversations directly via the Platform.
          </li>
        </ul>
        <p className="mb-2">
          Selection Process: Startups featured in the 'Invest in Startups' page
          will be chosen based on their traction, clarity of value proposition,
          and readiness for investment. TACTOS will analyze the startup and
          approve them to post their fundraising content.
        </p>
        <p className="mb-2">
          Fundraising Content Policy: All fundraising content must be submitted
          for approval by TACTOS and will be reviewed within 36 to 48 hours.
          Only approved content will be made visible on the Platform.
        </p>
        <p className="mb-2 font-semibold">Disclaimer:</p>
        <p className="mb-2">
          While TACTOS facilitates introductions and visibility through this
          feature, we do not participate in, mediate, or guarantee the success
          of any investment negotiations or deals. Startups and investors are
          solely responsible for conducting their own due diligence prior to
          entering into any financial or legal commitments. TACTOS shall not be
          held liable for any loss, damages, or disputes arising from investment
          discussions, negotiations, or transactions initiated through this
          feature.
        </p>
        <p className="mb-2">
          We reserve the right to add, remove, or modify any aspect of this
          feature without prior notice.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          6. Startup Dashboards and Event Visibility
        </h2>
        <p>
          Details related to startup dashboard features and event visibility.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">7. Job Portal Disclaimer</h2>
        <p className="mb-2">
          The TACTOS job portal is designed to help startups connect with
          potential talent and provide job opportunities to entrepreneurial
          professionals.
        </p>
        <p className="mb-2 font-semibold">Important Notes:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            TACTOS acts solely as a facilitator and does not screen, verify, or
            endorse job seekers or employers.
          </li>
          <li>We do not guarantee the hiring or job placement outcomes.</li>
          <li>
            We do not guarantee the performance or reliability of candidates or
            employers.
          </li>
          <li>
            Any hiring decision or employment relationship formed through the
            Platform is the sole responsibility of the parties involved.
          </li>
        </ul>
        <p className="mb-2 font-semibold">Users are advised to:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            Exercise independent due diligence when applying for or offering
            jobs.
          </li>
          <li>
            Ensure all job descriptions and applications submitted are accurate
            and truthful.
          </li>
        </ul>
        <p className="mb-2">
          TACTOS shall not be liable for any employment disputes,
          misrepresentation, non-performance, or other issues arising from job
          interactions on the Platform.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">8. User Accounts</h2>
        <p className="mb-2">
          To access certain features, you may be required to create an account.
          You agree to:
        </p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Provide accurate, current, and complete information</li>
          <li>Maintain the confidentiality of your login credentials</li>
          <li>Notify us immediately of any unauthorized use of your account</li>
        </ul>
        <p className="mb-2">
          You are solely responsible for all activities under your account.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">9. User Responsibilities</h2>
        <p className="mb-2">You agree not to:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Violate any applicable laws or regulations</li>
          <li>
            Upload or share content that is unlawful, harmful, defamatory, or
            infringing
          </li>
          <li>Interfere with the operation or security of the Platform</li>
          <li>
            Use bots, scrapers, or automated systems without our written consent
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          10. Intellectual Property
        </h2>
        <p className="mb-2">
          All content on the Platform, including logos, text, graphics,
          software, and trademarks, is the property of TACTOS or its licensors.
          You may not copy, reproduce, distribute, or create derivative works
          without express permission.
        </p>
        <p className="mb-2">
          User-submitted content remains yours, but by submitting it to the
          Platform, you grant TACTOS a non-exclusive, royalty-free, worldwide
          license to use, display, and distribute it for the purpose of
          operating and promoting the Platform.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          11. Startup Quotes and Tech Support Services
        </h2>
        <p className="mb-2">
          TACTOS provides startups with feature quotations based on their
          specified budget. These are non-binding estimates and are subject to
          revision upon further discussion.
        </p>
        <p className="mb-2">
          TACTOS serves as a third-party facilitator, aiming to ensure that
          services are delivered within the agreed budget and timeline. We do
          not directly develop or deliver these services; instead, we connect
          startups with appropriate service providers based on their
          requirements and budget.
        </p>
        <p className="mb-2">
          While we make every reasonable effort to coordinate and support the
          process transparently—with no hidden fees or commissions—the final
          delivery remains the responsibility of the respective service
          providers.
        </p>
        <p className="mb-2">Our role is to:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Help startups define their requirements clearly</li>
          <li>
            Connect them with service providers who can deliver accordingly
          </li>
          <li>
            Ensure that all communications, budget agreements, and deliverables
            are documented
          </li>
          <li>
            Monitor progress to the extent possible to prevent discrepancies
          </li>
          <li>
            Provide a platform for startups to exhibit their business to attract
            funding opportunities
          </li>
        </ul>
        <p className="mb-2">
          TACTOS is committed to protecting startup interests by promoting
          accountability, transparency, and cost clarity throughout the
          collaboration. However, we are not liable for the performance
          failures, delays, or disputes arising from third-party engagements or
          startup misuse of our estimates.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          12. Community Engagement and Collaboration Tools
        </h2>
        <p className="mb-2">
          TACTOS provides integrated collaboration tools, networking features,
          and access to student volunteers, mentors, and advisors for startups.
          These resources are offered to enhance community-driven innovation and
          entrepreneurial learning. Access to these features is subject to
          availability and relevance to your startup's mission and stage.
        </p>
        <p className="mb-2">Startups agree to:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Respect the contributions of volunteers and community members</li>
          <li>Use collaboration features responsibly and constructively</li>
        </ul>
        <p className="mb-2">
          TACTOS does not guarantee availability or performance of volunteers or
          mentors and is not liable for outcomes from these interactions.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">13. Data Privacy</h2>
        <p className="mb-2">
          Your use of the Platform is also governed by our Privacy Policy. By
          using the Platform, you consent to the collection, use, and disclosure
          of your data in accordance with our Privacy Policy.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">14. Termination</h2>
        <p className="mb-2">
          TACTOS reserves the right to suspend or terminate your access to the
          Platform at any time, without prior notice, for conduct that violates
          these Terms or is harmful to other users or the integrity of the
          Platform.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">15. Changes to Terms</h2>
        <p className="mb-2">
          We may update these Terms from time to time. We will notify you of
          material changes, but it is your responsibility to review the Terms
          periodically. Continued use of the Platform after changes constitutes
          acceptance of the updated Terms.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          16. Matrimony Section for Entrepreneurs
        </h2>
        <p className="mb-2">
          TACTOS provides a unique matrimony feature designed exclusively for
          entrepreneurs. This section of the Platform allows entrepreneurs to:
        </p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            Create personal profiles to share their background, interests, and
            preferences
          </li>
          <li>
            Browse other entrepreneur profiles seeking life partners with
            similar ambitions and lifestyle choices
          </li>
          <li>Send and receive connection requests within the Platform</li>
        </ul>
        <p className="mb-2 font-semibold">Matrimony Registration Fee:</p>
        <p className="mb-2">
          The fee for registering on the Matrimony platform is ₹5000. This fee:
        </p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Grants access for one year from the date of registration</li>
          <li>Is non-refundable under all circumstances</li>
        </ul>
        <p className="mb-2 font-semibold">Key Disclaimers:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            TACTOS acts solely as a facilitator and does not verify, endorse, or
            validate any information provided in user profiles.
          </li>
          <li>
            Users participate in the Matrimony feature at their own risk and are
            advised to exercise due diligence before initiating any interaction
            or relationship.
          </li>
          <li>
            Images, contact numbers, and other personal details are shared
            voluntarily by users, and TACTOS is not liable for any misuse or
            consequences arising from such disclosures.
          </li>
          <li>
            TACTOS does not guarantee a successful match, engagement, or
            marriage through this service.
          </li>
        </ul>
        <p className="mb-2">
          By using the Matrimony feature, you acknowledge that:
        </p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            You are solely responsible for your communication and interactions
            with other users
          </li>
          <li>
            You understand and accept that TACTOS bears no liability for
            emotional, financial, or legal implications of any relationship
            initiated via this Platform
          </li>
        </ul>
        <p className="mb-2">
          We reserve the right to monitor and moderate this section and to
          remove profiles or users that violate our community guidelines or are
          found engaging in fraudulent or inappropriate behavior.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          17. Job Portal Disclaimer
        </h2>
        <p className="mb-2">
          The TACTOS job portal is designed to help startups connect with
          potential talent and provide job opportunities to entrepreneurial
          professionals.
        </p>
        <p className="mb-2 font-semibold">Important Notes:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            TACTOS acts solely as a facilitator and does not screen, verify, or
            endorse job seekers or employers.
          </li>
          <li>We do not guarantee the hiring or job placement outcomes.</li>
          <li>
            We do not guarantee the performance or reliability of candidates or
            employers.
          </li>
          <li>
            Any hiring decision or employment relationship formed through the
            Platform is the sole responsibility of the parties involved.
          </li>
        </ul>
        <p className="mb-2 font-semibold">Users are advised to:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            Exercise independent due diligence when applying for or offering
            jobs.
          </li>
          <li>
            Ensure all job descriptions and applications submitted are accurate
            and truthful.
          </li>
        </ul>
        <p className="mb-2">
          TACTOS shall not be liable for any employment disputes,
          misrepresentation, non-performance, or other issues arising from job
          interactions on the Platform.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">18. Contact</h2>
        <p className="mb-2">
          For any questions about these Terms, please contact us at:{" "}
          <a
            href="mailto:tactosinfo@gmail.com"
            className="text-blue-600 hover:underline"
          >
            tactosinfo@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
